import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "@/api/client";
import imageOne from "../../resource/community/paritta/1.png";
import imageTwo from "../../resource/community/paritta/5.png";
import imageThree from "../../resource/community/paritta/2.png";
import imageFour from "../../resource/community/paritta/3.png";
import BookingCalendar from "../Calendar/BookingCalendar";
import TitleChange from "../../Hook/TitleChnage";

const Paritta = () => {
    TitleChange("Paritta at Home");

    const navigate = useNavigate();
    const [bookedDates, setBookedDates] = useState([]);
    const [blockedDates, setBlockedDates] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchParittaDates = async () => {
            try {
                const response = await apiClient.get('/get-paritta-at-home-requests');
                const data = response.data;
                // Adjust based on your API response structure
                setBookedDates(data.booked || []);
                setBlockedDates(data.blocked || []);
            } catch (error) {
                console.error("Failed to fetch Paritta dates:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchParittaDates();
    }, []);

    const handleRefresh = async () => {
        try {
            const response = await apiClient.get('/get-paritta-at-home-requests');
            const data = response.data;
            setBookedDates(data.booked || []);
            setBlockedDates(data.blocked || []);
        } catch (error) {
            console.error("Failed to refresh Paritta dates:", error);
        }
    };

    const handleClick = (event) => {
        const pathMap = {
            parittainstructions: "/parittainstructions",
            homerequestformparitta: "/homerequestformparitta",
        };
        const path = event.currentTarget.id;
        const targetPath = pathMap[path];
        if (targetPath) {
            navigate(targetPath);
        }
    };

    if (loading) {
        return (
            <div className="paritta-page inside-pages">
                <div className="right-box">
                    <img src={imageOne} alt="Right Top Image" className="right-image" width={300} />
                </div>
                <div className="text-center p-4">
                    <h1 className="font-main dark-gold p-4">Loading calendar data...</h1>
                </div>
            </div>
        );
    }

    return (
        <div className="paritta-page inside-pages">
            <div className="right-box">
                <img src={imageOne} alt="Right Top Image" className="right-image" width={300} />
            </div>

            <h1 className="font-main p-4">Paritta at Home</h1>

            <p className="h4 p-4 mt-5">
                In Buddhist culture, the Paritta chanting ceremony is an important part
                of special days and events, such as moving to a new home, starting a new
                job, celebrating a birthday, or sharing merits with departed relatives.
                While Paritta chanting is often a daily practice in a Buddhist home,
                having a ceremony with Sangha participation makes it even more
                auspicious and impactful, radiating positive vibrations of serene
                blessings and protection.
            </p>
            <p className="h4 p-4 mt-5">
                To secure a date for Paritta chanting at home, please refer to the
                Paritta Calendar.
            </p>

            <div className="calander-box">
                <div className="calnder mt-5">
                    <BookingCalendar
                        bookedDates={bookedDates}
                        blockedDates={blockedDates}
                        filterType="all"
                        showRefreshButton={true}
                        onRefresh={handleRefresh}
                    />
                </div>
            </div>

            <p className="h4 p-4 mt-5">
                The video is also available to help you understand the process of
                performing the Paritta pinkama.
            </p>

            <div className="btn-group mt-6">
                <img
                    src={imageFour}
                    alt="Right Top Image"
                    width={300}
                    onClick={handleClick}
                    id="parittainstructions"
                    className="curser-pointer"
                />
            </div>

            <div className="mt-6 calander-box align-item-center p-4 text-center">
                <div className="c-details text-left">
                    <h2 className="intro-text">Contact Details</h2>
                    <p className="font-p mt-4">Monastery : 035608 0918 / 0459 729 738</p>
                    <p className="font-p">Mr Gamini : 0422 069 359</p>
                    <p className="font-p">WhatsApp : 0422 069 359</p>
                    <p className="font-p">E-mail : info@bvp.org.au</p>
                </div>
                <div className="d-button">
                    <img
                        src={imageTwo}
                        alt="Right Top Image"
                        className="right-image curser-pointer"
                        id="homerequestformparitta"
                        onClick={handleClick}
                        width={300}
                    />
                </div>
            </div>

            <div className="bottom-box mt-5">
                <img src={imageThree} alt="bottom-image" width={600} />
            </div>
        </div>
    );
};

export default Paritta;